import React from 'react';
import CoreGroup from './../group/CoreGroup.js';

export default function TitleOnly({val}){
	const {childNodes} = val;
	return( <div> {childNodes && childNodes.map((g,i) => <CoreGroup val = {g} key={i}/>)} </div> )
}